import React from 'react';
import FinalRegistrationPage from '../reusableComponents/FinalRegistrationPage/FinalRegistrationPage'
const RegistrationSuccess = (props) => {
    return (
        <FinalRegistrationPage
            image={props.image}
            title={props.title}
            subtitle1={props.subtitle1}
            subtitle2={props.subtitle2}
            showResendEmail={props.showResendEmail}
        />
    )
}

export default RegistrationSuccess;